var serverActions = {
  loginClient: 'open_client_session',
  loginInstalator: 'open_engineer_session'
};

var serverConnectorService;
var q;
var instance;
var localStorage
var currentUserWebsocket;
var roles;
var $rootScope;

class LoginService {
    constructor($q, ServerConnectorService, $localStorage, ROLES, $rootScope) {
      instance = this;
      q = $q;
      serverConnectorService = ServerConnectorService;
      localStorage = $localStorage;
      roles = ROLES;
      this.$rootScope = $rootScope;

      this.login = this.login.bind(this);
    }
    
    login(login, password, role){
      var deferred = q.defer();
      if(currentUserWebsocket){
        currentUserWebsocket.close();
      }
      currentUserWebsocket = serverConnectorService.connect();
      
      var request = {
        password : password
      };

      if(role === roles.client){
        request.email = login;
        request.action_name = serverActions.loginClient;
      }else if(role === roles.instalator){
        request.license_id = login;
        request.action_name = serverActions.loginInstalator;
      }else {
        console.error('role not known');
        deferred.reject();
        return;
      }

      var onMessage = function(data){
        // instance.$rootScope.$broadcast('server-userLoggedIn');
        deferred.resolve({login: login});
      }

      serverConnectorService.send(request, currentUserWebsocket, deferred, onMessage);
      return deferred.promise;
    }

    getCurrentUserWebsocket(){
      return currentUserWebsocket;
    }

    static factory($q, ServerConnectorService, $localStorage, ROLES, $rootScope){
        return new LoginService($q, ServerConnectorService, $localStorage, ROLES, $rootScope);
    }
}

LoginService.factory.$inject = ['$q', 'ServerConnectorService', '$localStorage', 'ROLES', '$rootScope'];

export default LoginService = LoginService.factory;


// WEBPACK FOOTER //
// ./src/service/server-connector/login.service.js